export enum TowerLocations {
  RoofMounted = 1,
  Ground = 2,
}
